var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7007 8.45602L13.462 1.08508C13.0204 -0.361694 10.9796 -0.361694 10.5532 1.08508L8.2993 8.45602H1.52231C0.0450744 8.45602 -0.564094 10.3597 0.639014 11.2125L6.18244 15.1721L4.00467 22.1928C3.56302 23.6091 5.20778 24.7513 6.38042 23.8527L12 19.5886L17.6196 23.868C18.7922 24.7665 20.437 23.6243 19.9953 22.208L17.8176 15.1873L23.361 11.2277C24.5641 10.3597 23.9549 8.47125 22.4777 8.47125H15.7007V8.45602Z",
    fill: "#AEB0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.13ef73aa7eab4dced07a3d25ef4e3eb8.svg";
export { ForwardRef as ReactComponent };